module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "countdown-plp-wrapper",
    class: {
      'countdown-cart-wrapper': _vm.callerComp === 'cart',
      'countdown-imgblock-wrapper': _vm.callerComp === 'imgBlock'
    }
  }, [(_vm.showEarlyText) ? _c('div', {
    staticClass: "text-center"
  }, [_c('span', {
    staticClass: "pretext"
  }, [_vm._v(" " + _vm._s(this.pretext))])]) : _vm._e(), _vm._v(" "), (this.now < this.endtime) ? _c('div', {
    staticClass: "text-center",
    class: _vm.secondUI ? 'timer1' : _vm.mobileUI ? 'mobile-ui' : 'timer',
    style: (("color: " + (_vm.color ? _vm.color : '#333')))
  }, [((this.now >= this.starttime && this.now < this.endtime && this.pretext && !_vm.showEarlyText && !_vm.secondUI && !_vm.mobileUI)) ? _c('span', {
    staticClass: "pretext"
  }, [_vm._v(" " + _vm._s(this.pretext) + " ")]) : _vm._e(), _vm._v(" "), ((this.now >= this.starttime && this.now < this.endtime && this.pretext && !_vm.showEarlyText && _vm.secondUI || _vm.mobileUI)) ? _c('span', {
    staticClass: "pretext1"
  }, [_vm._v(" " + _vm._s(this.pretext) + " ")]) : (this.now > this.endtime) ? _c('span', {
    staticStyle: {
      "font-size": "0.63em"
    }
  }, [_vm._v("\n      " + _vm._s(this.successtext) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), (this.now >= this.starttime && this.now < this.endtime && _vm.showTimer && !_vm.secondUI && !_vm.mobileUI) ? _c('div', {
    staticClass: "countdown"
  }, [_c('div', {
    staticClass: "time"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.days)))]), _vm._v(" "), _c('p', {
    staticClass: "unit"
  }, [_vm._v("days :")])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.hours)))]), _vm._v(" "), _c('p', {
    staticClass: "unit"
  }, [_vm._v("hrs :")])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.minutes)))]), _vm._v(" "), _c('p', {
    staticClass: "unit"
  }, [_vm._v("min :")])]), _vm._v(" "), _c('div', {
    ref: "seconds",
    staticClass: "time"
  }, [_c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.seconds)))]), _vm._v(" "), _c('p', {
    staticClass: "unit"
  }, [_vm._v("sec")])])]) : _vm._e(), _vm._v(" "), (this.now >= this.starttime && this.now < this.endtime && _vm.showTimer && _vm.secondUI) ? _c('div', {
    staticClass: "countdown",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "time1"
  }, [_c('span', {
    staticClass: "number1"
  }, [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.days)))]), _vm._v(" "), _c('div', {
    staticClass: "unit1 text-uppercase"
  }, [_vm._v("day")])]), _vm._v(" "), _c('span', {
    staticClass: "two-dot"
  }, [_vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "time1"
  }, [_c('span', {
    staticClass: "number1"
  }, [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.hours)))]), _vm._v(" "), _c('div', {
    staticClass: "unit1 text-uppercase"
  }, [_vm._v("hr")])]), _vm._v(" "), _c('span', {
    staticClass: "two-dot"
  }, [_vm._v(":")]), _vm._v(" "), _c('div', {
    staticClass: "time1"
  }, [_c('span', {
    staticClass: "number1"
  }, [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.minutes)))]), _vm._v(" "), _c('div', {
    staticClass: "unit1 text-uppercase"
  }, [_vm._v("min")])]), _vm._v(" "), _c('span', {
    staticClass: "two-dot"
  }, [_vm._v(":")]), _vm._v(" "), _c('div', {
    ref: "seconds",
    staticClass: "time1"
  }, [_c('span', {
    staticClass: "number1"
  }, [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.seconds)))]), _vm._v(" "), _c('div', {
    staticClass: "unit1 text-uppercase"
  }, [_vm._v("sec")])])]) : _vm._e(), _vm._v(" "), (this.now >= this.starttime && this.now < this.endtime && _vm.showTimer && _vm.mobileUI) ? _c('div', {
    staticClass: "mobileUI countdown pt-0 pb-2"
  }, [_c('span', {
    staticClass: "number1"
  }, [_vm._v(_vm._s(_vm._f("twoDigits")(_vm.days)) + " "), _c('span', {
    staticClass: "timerFormat"
  }, [_vm._v(_vm._s((_vm.days) > 1 ? 'days' : 'day') + " : ")]), _vm._v(_vm._s(_vm._f("twoDigits")(_vm.hours)) + " "), _c('span', {
    staticClass: "timerFormat"
  }, [_vm._v("hrs : ")]), _vm._v(_vm._s(_vm._f("twoDigits")(_vm.minutes)) + " "), _c('span', {
    staticClass: "timerFormat"
  }, [_vm._v("min : ")]), _vm._v(_vm._s(_vm._f("twoDigits")(_vm.seconds)) + " "), _c('span', {
    staticClass: "timerFormat"
  }, [_vm._v("sec")])])]) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2168c715"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CountdownPLP.vue
// module id = 1077
// module chunks = 111